import { fetchLanguage, fetchLocation } from '@nike/privacy-shared-logic';
import type { ContextFrame, ContextFrameNamesModal } from '@nike/privacy-types';

/**
 * @name initializeNikePrivacy
 * @description Initialize NikePrivacy
 * @returns {Promise<void>}
 * @memberof mfe-privacy-consent
 */
export const initializeNikePrivacy = async (): Promise<void> => {
  const language = fetchLanguage();
  const country = fetchLocation();

  if (!window.webShellClient?.identity) throw new Error();

  return await window.NikePrivacy.initialize({
    webShellIdentity: window.webShellClient.identity,
    country,
    language,
  });
};

/**
 * @name getInteractions
 * @description Gets a ContextFrame
 * @param {ContextFrameNamesModal} contextFrameName - a namespace to retrieve interactions from
 * @returns {ContextFrame|undefined}
 * @memberof mfe-privacy-consent
 */
export const getInteractions = (
  contextFrameName: ContextFrameNamesModal,
): ContextFrame | undefined =>
  window.NikePrivacy.interactions.get(contextFrameName, contextFrameName);
